/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { RichText } from '@fiverr-private/cms_ui';

import { PageContainer } from '../../PageContainer';
import { getEmbeddedComponents } from '../../constants';
import EventsReporter from '../../../utils/events/reporter';
import { trackPageEvent } from '../../../utils/events/gtm';
import { EventTypes } from '../../../utils/events/types';

const GeneralPage = ({ chapterContent, comeetPositions, teamId, pageName, pageClasses, queryParams, gtm }) => {
    useEffect(() => {
        const params = { pageName, teamId };
        if (queryParams?.location) {
            params.location = queryParams.location;
        }
        EventsReporter.report(EventTypes.pageView, params);
    }, [pageName, teamId, queryParams]);

    useEffect(() => {
        if (gtm) {
            trackPageEvent(gtm);
        }
    }, [gtm]);

    return (
        <PageContainer className={pageClasses}>
            {chapterContent && (
                <RichText
                    {...chapterContent}
                    embeddedComponents={getEmbeddedComponents({ comeetPositions, queryParams, teamId })}
                />
            )}
        </PageContainer>
    );
};

GeneralPage.propTypes = {
    chapterContent: PropTypes.object,
    comeetPositions: PropTypes.array,
};

export default GeneralPage;
